import useParticipants from '../useParticipants/useParticipants';
import useDominantSpeaker from '../useDominantSpeaker/useDominantSpeaker';
import { useEffect, useState } from 'react';
import type { AgoraParticipantLike } from '../../types';

export default function useSpeakerViewParticipants(): AgoraParticipantLike[] {
  const participants = useParticipants();
  const dominantSpeaker = useDominantSpeaker();
  const [ordered, setOrdered] = useState<AgoraParticipantLike[]>(participants);

  useEffect(() => {
    if (dominantSpeaker) {
      setOrdered(prev => [dominantSpeaker, ...prev.filter(p => p !== dominantSpeaker)]);
    }
  }, [dominantSpeaker]);

  useEffect(() => {
    setOrdered(participants);
  }, [participants]);

  return ordered;
}
